import SiteNavbar from "@/pages/home/components/SiteNavbar";
import HeroSection from "@/pages/home/components/HeroSection";
import ProfileSection from "@/pages/home/components/ProfileSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import SocialSection from "@/pages/home/components/SocialSection";
import GossipSection from "@/pages/home/components/GossipSection";
import RankingSection from "@/pages/home/components/RankingSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import DisclaimerSection from "@/pages/home/components/DisclaimerSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNavbar />
      <main className="w-full">
        <HeroSection />
        <ProfileSection />
        <TimelineSection />
        <SocialSection />
        <GossipSection />
        <RankingSection />
        <GuideSection />
        <FaqSection />
        <DisclaimerSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}